import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import Button from '@/components/Button/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import { ToastContext } from '@/context/toast/index'
import rem from '@/utils/rem'
import { useFormik } from 'formik'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

const validationSchema = yup.object({
	referenceNumber: yup
	.string('Enter your Reference Number')
	.min(8, 'Reference Number should be minimum of 8 characters length')
	.max(32, 'Reference Number should be of 32 characters length')
	.required('Reference Number is required'),
})

export default function AddReferenceNumberModal({ visible, close, submit }) {
	const { addToastMessage } = useContext(ToastContext)
	const { t } = useTranslation()
	const formik = useFormik({
		initialValues: {
			referenceNumber: '',
		},
		validationSchema: validationSchema,
		validateOnMount: true,
		onSubmit: async (data) => {
			submit(data.referenceNumber)
		},
	})

	const ErrorMessage = ({ name }) =>
		formik.errors[name] && formik.touched[name] ? (
			<div className="error-message">{formik.errors[name]}</div>
		) : null

	return (
		<Modal visible={visible} variant='medium'  close={close}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">

								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Add my unique Reference ID
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						{/* <div style={{ fontSize: rem(14), textAlign: 'center' }}>Are you sure you want to cancel Simulation?</div> */}
						<div className="eclip-receipient__input">
						<span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span">
							Reference ID
						</span>
						<input
							type="text"
							name="referenceNumber"
							value={formik.values.referenceNumber}
							onChange={formik.handleChange}
							placeholder="Enter ID"
						/>
						<div className="eclip-create__input-description">
							{t('referenceNumberDescription')}
						</div>
						<ErrorMessage name="expectedDateOfCompletion" />
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={close} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button
							text="Send"
							disabled={!formik.isValid}
							submit={() => {
								submit(formik.values.referenceNumber)
							}}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
